import { Dictionary } from "../../../../../types";
import { StoreFeature } from "../../../core/store/types";

export interface BrowseSettings extends Dictionary<string, any>
{
    autoSelectRows: boolean;
    canBeSelected: boolean;
    manuallyHandleKeyboardNavigation: boolean;
    deselectOnUnFocus: boolean;
    isStaticHeight: boolean;
    infiniteScrollBodyIDOverride: string | undefined;
    infiniteScrollBodyClassOverride: string | undefined;
    headerCellPositionSticky: boolean;
}

export const settings: StoreFeature<BrowseSettings> = {}
